import { SectionItems } from '@varo/graphql-schema-types';
import StandardCard from 'features/rewards/components/StandardCard/StandardCard';
import { rewardsActionNavigation } from 'features/rewards/helpers/DetermineDestination.helpers';
import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import { parseGQLAnalyticsEvent } from 'services/analytics/helpers/parseGQLAnalyticsEvent';
import theme from 'shared/styles/theme';

export interface StandardCardCarouselProps {
  sectionData: SectionItems[];
  sectionName?: string;
}

const StandardCardCarousel = ({
  sectionData,
  sectionName,
}: StandardCardCarouselProps) => {
  return (
    <View style={styles.container}>
      <FlatList
        contentContainerStyle={styles.standardCardCarousel}
        data={sectionData}
        renderItem={({ item }) => (
          <StandardCard
            id={item.id}
            isNew={item.isNew}
            primaryText={item.title}
            secondaryText={item.subTitle ?? ''}
            incentiveText={item.cashback ?? ''}
            logoImage={{ uri: item.logoImage }}
            backgroundColor={
              item.backgroundColor
                ? item.backgroundColor.toLowerCase()
                : theme.color.background.tertiary
            }
            onPress={() => rewardsActionNavigation(item, sectionName)}
            analyticsId="partnerOfferSelected"
            customAttributes={
              item.onClick?.analyticsEvent
                ? parseGQLAnalyticsEvent(item.onClick.analyticsEvent).properties
                : null
            }
          />
        )}
        keyExtractor={(item) => item.id.toString()}
        horizontal
        showsHorizontalScrollIndicator={false}
        ItemSeparatorComponent={() => <View style={styles.separator}></View>}
        removeClippedSubviews={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: theme.spacing.m,
  },
  separator: {
    backgroundColor: 'transparent',
    width: theme.spacing.s,
  },
  standardCardCarousel: {
    paddingEnd: theme.spacing.m,
    paddingStart: theme.spacing.m,
  },
});

export default StandardCardCarousel;
